import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import axios from "axios";
import constants from "../../utils/constants";
import { QueryArguments } from "../../types-business/QueryArguments";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";

const CLUBS_BASE_URL = "/api/activity-logs";

export const getBinnacleByPartnerMembership = (params?: any): IAction => {
  return {
    type: actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER_MEMBERSHIP,
    payload: {
      promise: axios.get(
        `${constants.BASE_URL}${CLUBS_BASE_URL}/by-partner-membership`,
        {
          withCredentials: true,
          params: { ...params, ...constants.DEFAULT_SORTING_PARAMS }
        }
      )
    }
  };
};

export const getBinnacleByPartner = (params?: QueryArguments): IAction => {
  return {
    type: actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER,
    payload: {
      promise: axios.get(`${constants.BASE_URL}${CLUBS_BASE_URL}/by-partner`, {
        withCredentials: true,
        params: params
      })
    }
  };
};

export const getBinnacleByPartnerMembershipAxios = (args?: any) => {
  return axios.get(
    `${constants.BASE_URL}${CLUBS_BASE_URL}/by-partner-membership`,
    {
      withCredentials: true,
      params: { ...args, sort: "desc" }
    }
  );
};

export const getModules = (): IAction => {
  return {
    type: actionTypes.GET_ACTIVITY_LOGS_MODULES,
    payload: {
      promise: axios.get(`${constants.BASE_URL}${CLUBS_BASE_URL}/modules`, {
        withCredentials: true
      })
    }
  };
};

export const resetBinnacle = (): IAction => {
  return {
    type: actionTypes.RESET_ACTIVITY_LOGS,
    payload: null
  };
};

export const generateCSVByPartner = async (
  callback: any,
  params?: QueryArguments
) => {
  try {
    let latestPage = false;
    let page = 0;
    let csvData = "Usuario, Membresia, Fecha, Modulo, Descripción";
    let counter = 0;
    let totalElements = 0;
    while (!latestPage) {
      const response = await axios.get(
        `${constants.BASE_URL}${CLUBS_BASE_URL}/by-partner`,
        { withCredentials: true, params: { ...params, page: page, all: true } }
      );

      if (200 !== response.status)
        throw new Error("Error al obtener la página " + page);

      counter += response.data.length;
      totalElements = response.data.totalElements;
      page++;
      latestPage = counter >= totalElements;
      csvData += `\n${response.data.csv}`;
    }
    FileDownload(csvData, `Bitacora${params.startDate}-${params.endDate}.csv`);
  } catch (error) {
    console.error("Error al generar el reporte de bitácora", error);
    errorNotification("No se pudo generar el contenido a CSV");
  } finally {
    callback && callback();
  }
};
